/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCapturesRequest
 */
export interface GetCapturesRequest {
    /**
     * 
     */
    captureIds: Array<string>;
}

/**
 * Check if a given object implements the GetCapturesRequest interface.
 */
export function instanceOfGetCapturesRequest(value: object): value is GetCapturesRequest {
    if ((!('captureIds' in (value as Record<string, any>)) && !('capture_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureIds'] === undefined && (value as Record<string, any>)['capture_ids'] === undefined)) return false;
    return true;
}

export function GetCapturesRequestFromJSON(json: any): GetCapturesRequest {
    return GetCapturesRequestFromJSONTyped(json, false);
}

export function GetCapturesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCapturesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'captureIds': json['capture_ids'],
    };
}

export function GetCapturesRequestToJSON(json: any): GetCapturesRequest {
    return GetCapturesRequestToJSONTyped(json, false);
}

export function GetCapturesRequestToJSONTyped(value?: GetCapturesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_ids': value['captureIds'],
    };
}

